import { render, staticRenderFns } from "./AppWait.vue?vue&type=template&id=08f405a8&"
import script from "./AppWait.vue?vue&type=script&lang=js&"
export * from "./AppWait.vue?vue&type=script&lang=js&"
import style0 from "spinkit/scss/spinners/11-folding-cube.scss?vue&type=style&index=0&prod&lang=scss&"
import style1 from "./AppWait.vue?vue&type=style&index=1&id=08f405a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports